/*
 *  Document   : client-mission-edit.js
 *  Author     : Exapoint
 *
 */

// Import required modules

// Tools
import ExaHelpers from "../exa_helpers";
import Fuse from 'fuse.js';
import moment from 'moment';

export default class ClientMissionEdit {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ClientMissionEdit"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {

        ExaHelpers.select2();
        this.initDescriptionTextEditor();

        this.updateSystemHours( $('#start_date_datepicker').val(), $('#end_date_datepicker').val());

        this.initWorkingHours();

        this.markersArray = [];
        ExaHelpers.addScript(
            'https://maps.googleapis.com/maps/api/js?libraries=places&callback=Function.prototype&key=' + googleMapsApiKey,
            function () {
                this.initMap();
                this.initCountryRestriction(); // Triggers initAutocomplete
            }.bind(this)
        );

        ClientMissionEdit.initLanguagesSelect($('#candidate-edit-languages-select2'));

        this.latInput = $('[name="lat"]');
        this.lngInput = $('[name="lng"]');

        this.initDropzone();

        this.toggleNoEndDate({target: $('[name="no_end_date"]')});

        this.toggleSemaineType({target: $('[name="semaine_type"]')});

        this.$missionUpdateForm = $('#mission-update-form');

        ExaHelpers.validation();
        this.initValidation();

        $('#load-company-address').on('click', function (e) {
            let $target = $(e.target);
            let $customAddressContainer = $target.parent().find('.custom-address-container');

            $customAddressContainer.find('input').each(function (index, value) {
                let $el = $(value);
                let newValue = jsVars.companyInfo[$el.prop('name')];
                if (newValue !== "") {
                    $el.val(newValue);
                }
            });

            let latVal = parseFloat(this.latInput.val());
            let lngVal = parseFloat(this.lngInput.val());

            if (latVal > 0 || lngVal > 0) {
                this.showOnMap(parseFloat(this.latInput.val()), parseFloat(this.lngInput.val()));
            }

            this.updateLatLngInputs({lat: parseFloat(this.latInput.val()), lng: parseFloat(this.lngInput.val())});
        }.bind(this))

        this.initEndMission();

        this.initJobTitlesAutocomplete();

        this.$missionUpdateForm.find('[name="start_date"]').on('input', function (e) {
           let $endDate = $('[name="end_date"]');
            if ($endDate.length !== 0) {
                $endDate[0]._flatpickr.set('minDate', e.target._flatpickr.selectedDates[0]);
            }

            let $startDate = $('#start_date_datepicker');
             window["ClientMissionEdit"].updateSystemHours($startDate.val(), $('#end_date_datepicker').val());

        }).change();

        this.$missionUpdateForm.find('[name="end_date"]').on('input', function (e) {
            window["ClientMissionEdit"].updateSystemHours($('#start_date_datepicker').val(), $('#end_date_datepicker').val());
        }).change();


        this.$missionUpdateForm.find('[name="semaine_type_am_from"]').on('input', function (e) {
            //am_from
            $('.am_from').val($(this).val());
        }).change();

        this.$missionUpdateForm.find('[name="semaine_type_am_to"]').on('input', function (e) {
            //am_to
            $('.am_to').val($(this).val());
        }).change();

        this.$missionUpdateForm.find('[name="semaine_type_pm_from"]').on('input', function (e) {
            //pm_from
            $('.pm_from').val($(this).val());
        }).change();

        this.$missionUpdateForm.find('[name="semaine_type_pm_to"]').on('input', function (e) {
            //pm_to
            $('.pm_to').val($(this).val());
        }).change();


        this.changeMonthSystemHours();

        this.initWorkingHoursInput();

        this.initPotentialCandidatesNumber();

        if (jsVars.showEmptyLicences) {
            this.showEmptyLicencesAlert();
        }

        if (jsVars.showFelicitations) {
            this.showFelicitationsAlert();
        }

        $('.list_teamer_match').hide();
        $('#btn_teamer_match_allcheck').hide();
        $('#btn_teamer_match_uncheck').hide();

       $('#btn_teamer_match').on('click',function(e){

            if($('#btn_teamer_match').prop('checked') == true){
                    let $form = $(e.target).parents('form');
                    window["ClientMissionEdit"].loadPotentialCandidatesList($form);
                    $('#btn_teamer_match_allcheck').show();
                    $('#btn_teamer_match_uncheck').show();
            }else{
                    $('.list_teamer_match').html('').hide();
                    $('#btn_teamer_match_allcheck').hide();
                    $('#btn_teamer_match_uncheck').hide();
            }
       });

        if($('#btn_teamer_match').prop('checked') == true){
                let $form = $('#btn_teamer_match').parents('form');
                window["ClientMissionEdit"].loadPotentialCandidatesList($form);
                $('#btn_teamer_match_allcheck').show();
                $('#btn_teamer_match_uncheck').show();
        }

        let $editUserModal = $('#client-candidate-show-modal');
        ExaHelpers.bindCandidateInfoModal($editUserModal);

        $('#btn_teamer_match_allcheck').on('click',function(){
            $('.list_teamer_match input').prop('checked', true);
        });

        $('#btn_teamer_match_uncheck').on('click',function(){
            $('.list_teamer_match input').prop('checked', false);
        });

        if($('.case_cadencer_envoi').prop('checked') != true){
                $('.choix_cadencer_envoi').hide();
        }else{
                let $form = $('.case_cadencer_envoi').parents('form');
                window["ClientMissionEdit"].loadPotentialCandidatesCadenced($form);
        }

        $('.case_cadencer_envoi').on('click',function(){
            $('.choix_cadencer_envoi').toggle();

                if($('.case_cadencer_envoi').prop('checked') != true){
                        $('.choix_cadencer_envoi').hide();
                }else{
                        let $form = $('.case_cadencer_envoi').parents('form');
                        window["ClientMissionEdit"].loadPotentialCandidatesCadenced($form);
                }

        });

        $('#active-oui').on('change', function() {
            if ($(this).prop("checked")) {
               $('.btn-save').val('Enregistrer et lancer la mission');
            }else{
               $('.btn-save').val('Enregistrer la mission');
            }
        });

        /*$('.cadencedblock').hide();
        $('input[name="active"]').on('click',function(){
            if($('input[name="active"]:checked').val() == "withmatching"){
                $('.cadencedblock').show();
            }else{
                $('.cadencedblock').hide();
            }
        });*/


    }

    changeMonthSystemHours(){
        $('.list-month').on('click', 'a',function(e){
            e.preventDefault();

            $('div.card-mission-times-content').removeClass('visible');
            $('div.card-mission-times-content').filter("[data-tabs-month='"+$(this).attr('data-tabs-month')+"']").addClass('visible');
            $('.list-month a').removeClass('active');
            $(this).addClass('active');

            $(".horaires-travail").animate({ scrollTop: 0 }, "fast");
        });
    }

    updateSystemHours(start_date,end_date)
    {
        //date_format yyyy-mm-dd
        let $semaineTypeCheckboxContainer = $('.semaine-type-check');
        let $horairesTravailContainer = $('.horaires-travail');
        let $listMonth = $('.list-month');

        jsVars.affiliateThisTeamer

        console.log(jsVars.languages)

        let dicoMois = [ "Mois", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre",  "Décembre"];


        const locale = {
            fr: { key: 'fr', format: 'dddd Do MMMM YYYY', dicoMois: [ "Mois", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre",  "Décembre"] },
            en: { key: 'en', format: 'dddd, MMMM Do YYYY', dicoMois: [ "Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"] },
            it: { key: 'it', format: 'dddd Do MMMM YYYY', dicoMois: [ "Mese", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre",  "Dicembre"] },
            de: { key: 'de', format: 'dddd, Do. MMMM YYYY', dicoMois: [ "Monat", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November",  "Dezember"] },

        }

        if(this.isValidDate(start_date)) {
            if(this.isValidDate(end_date) && !$('[name="no_end_date"]').prop('checked') &&  end_date != '9999-12-31' )
            {
                var html ="";
                var list ="";
                //date de début et date de fin

                var aMois = [];
                var aList = [];

                var oStartDate = new Date(start_date);
                oStartDate.setHours( 0,0,0,0 );
                var oEndDate = new Date(end_date);
                oEndDate.setHours( 0,0,0,0 );

                var lastMonth = oStartDate.getMonth();

                var i = 0;

                for (var day = oStartDate; day <= oEndDate; day.setDate(day.getDate() + 1)) {
                    moment.locale(locale[jsVars.languages].key)
                    if(lastMonth != day.getMonth()){

                        list+= '<li><a href="#" data-tabs-month="tabs_'+i+'">'+ locale[jsVars.languages].dicoMois[parseInt(lastMonth)+1]+'</a></li>';
                        aMois[i] = html;
                        html = "";
                        i++;
                        lastMonth = day.getMonth();
                    }
                    html += `
                    <div class="row-content">
                        <span class="subtext text-secondary">${moment(day).format(locale[jsVars.languages].format)}</span>
                        <div class="card-mission-times-content-row">
                            <div class="card-mission-times-content-morning-afternoon">
                                <div class="checkbox">
                                    ${'<input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am\']" type="checkbox" value="am">'}
                                </div>
                                <div>
                                    <div class="timestamp-input d-flex align-items-center">
                                        <span class="timestamp_text">${jsVars.from}</span>
                                        ${'<div class="input"><input value="'+$('[name="semaine_type_am_from"]').val()+'" disabled="disabled" class="form-control horaires-time init-flatpickr-time am_from" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_from\']" type="text"></div>'}
                                        <span class="timestamp_text">h</span>
                                    </div>
                                    <div class="timestamp-input d-flex align-items-center">
                                        <span class="timestamp_text">${jsVars.to}</span>
                                        ${'<div class="input"><input value="'+$('[name="semaine_type_am_to"]').val()+'" disabled="disabled" class="form-control horaires-time init-flatpickr-time am_to" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_to\']" type="text"></div>'}
                                        <span class="timestamp_text">h</span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-mission-times-content-morning-afternoon">
                                <div class="checkbox">
                                    ${'<input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm\']" type="checkbox" value="pm">'}
                                </div>
                                <div>
                                    <div class="timestamp-input d-flex align-items-center">
                                        <span class="timestamp_text">${jsVars.from}</span>
                                        ${'<div class="input"><input value="'+$('[name="semaine_type_pm_from"]').val()+'" disabled="disabled" class="form-control horaires-time init-flatpickr-time pm_from" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_from\']" type="text"></div>'}
                                        <span class="timestamp_text">h</span>
                                    </div>
                                    <div class="timestamp-input d-flex align-items-center">
                                        <span class="timestamp_text">${jsVars.to}</span>
                                        ${'<div class="input"><input value="'+$('[name="semaine_type_pm_to"]').val()+'" disabled="disabled" class="form-control horaires-time init-flatpickr-time pm_to" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_to\']" type="text"></div>'}
                                        <span class="timestamp_text">h</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    `


                }

                aMois[i] = html;
                list+= '<li><a href="#" data-tabs-month="tabs_'+i+'">'+locale[jsVars.languages].dicoMois[parseInt(oEndDate.getMonth())+1]+'</a></li>';

                html="";

                aMois.forEach((item, index) => {
                    html += '    <div class="card-mission-times-content" data-tabs-month="tabs_' + index + '">';
                    html += item;
                    html +=  '    </div>';

                })

                $horairesTravailContainer.html(html);
                $listMonth.find('ul').html(list);

                $horairesTravailContainer.find('div.card-mission-times-content').first().addClass('visible');
                $listMonth.find('a').first().addClass('active');

                $semaineTypeCheckboxContainer.show();

            }else{
                //unisuement date de debut
                let [start_date_year, start_date_month, start_date_day] = start_date.split('-');
                var html ="";
                var list ="";

                var oStartDate = new Date(start_date);
                var day = oStartDate;
                    html = `
                    <div class="card-mission-times-content d-flex visible" ${'data-tabs-month="tabs_' + start_date_month + '_' + start_date_year + '"'}>
                        <div class="row-content">
                            <span class="subtext text-secondary">${moment(start_date).format(locale[jsVars.languages].format)}
                            <div class="card-mission-times-content-row">
                                <div class="card-mission-times-content-morning-afternoon">
                                    <div class="checkbox">
                                        ${'<input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\'' + day.getDate() + '-' + (day.getMonth() + 1) + '-' + day.getFullYear() + '\'][\'am\']" type="checkbox" value="true">'}
                                    </div>
                                    <div>
                                        <div class="timestamp-input d-flex align-items-center">
                                            <span class="timestamp_text">${jsVars.from}</span>
                                            ${'<div class="input"><input value="08:00" disabled="disabled" class="form-control init-flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_from\']" type="text"></div>'}
                                            <span class="timestamp_text">h</span>
                                        </div>
                                        <div class="timestamp-input d-flex align-items-center">
                                            <span class="timestamp_text">${jsVars.to}</span>
                                            ${'<div class="input"><input value="12:00" disabled="disabled" class="form-control init-flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_to\']" type="text"></div>'}
                                            <span class="timestamp_text">h</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-mission-times-content-morning-afternoon">
                                    <div class="checkbox">
                                        ${'<input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+start_date_day+'-'+start_date_month+'-'+start_date_year+'\'][\'pm\']" type="checkbox" value="true">'}
                                    </div>
                                    <div>
                                        <div class="timestamp-input d-flex align-items-center">
                                            <span class="timestamp_text">${jsVars.from}</span>
                                            ${'<div class="input"><input value="14:00" disabled="disabled" class="form-control init-flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_from\']" type="text"></div>'}
                                            <span class="timestamp_text">h</span>
                                        </div>
                                        <div class="timestamp-input d-flex align-items-center">
                                            <span class="timestamp_text">${jsVars.to}</span>
                                            ${'<div class="input"><input value="17:00" disabled="disabled" class="form-control init-flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_to\']" type="text"></div>'}
                                            <span class="timestamp_text">h</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                $horairesTravailContainer.html(html);

                list = '<li><a href="#" class="active" data-tabs-month="tabs_'+start_date_month+'_'+start_date_year+'">'+locale[jsVars.languages].dicoMois[parseInt(start_date_month)]+'</a></li>'
                $listMonth.find('ul').html(list);

                $semaineTypeCheckboxContainer.hide();

            }

            let $input = $('.init-flatpickr-time.horaires-time');

            $input.addClass('js-flatpickr-enabled');
            flatpickr($input, {
                //disableMobile: "true",
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
            //    defaultDate: this.getInputDefaultTime.apply(this, ['flatpickr-time']),
                onReady: function (selectedDates, dateStr, instance) {
                    if (instance.isMobile) {
                        $(instance.mobileInput).attr('step', null);
                    }
                },
            });


            $('#SystemHours').show();
            $('.message_date_debut_first').hide();
        }
        else
        {
            //pas de date de début

            $('#SystemHours').hide();
            $('.message_date_debut_first').show();
        }


    }

    // updateSystemHours(start_date,end_date)
    // {
    //     //date_format yyyy-mm-dd
    //     let $semaineTypeCheckboxContainer = $('.semaine-type-check');
    //     let $horairesTravailContainer = $('.horaires-travail');
    //     let $listMonth = $('.list-month');

    //     let dicoMois = [ "Mois", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre",  "Décembre"];

    //     if(this.isValidDate(start_date))
    //     {
    //         let [start_date_year, start_date_month, start_date_day] = start_date.split('-');

    //         if(this.isValidDate(end_date) && !$('[name="no_end_date"]').prop('checked') &&  end_date != '9999-12-31' )
    //         {
    //             let [end_date_year, end_date_month, end_date_day] = end_date.split('-');
    //             var html ="";
    //             var list ="";
    //             //date de début et date de fin

    //             var aMois = [];
    //             var aList = [];

    //             var oStartDate = new Date(start_date);
    //             oStartDate.setHours( 0,0,0,0 );
    //             var oEndDate = new Date(end_date);
    //             oEndDate.setHours( 0,0,0,0 );

    //             var lastMonth = oStartDate.getMonth();

    //             var i = 0;


    //             for (var day = oStartDate; day <= oEndDate; day.setDate(day.getDate() + 1)) {
    //              //   console.log(day+' ||| '+oEndDate+' ||| '+(day.getDate() + 1));


    //                 if(lastMonth != day.getMonth()){

    //                     list+= '<li><a href="#" data-tabs-month="tabs_'+i+'">'+dicoMois[parseInt(lastMonth)+1]+'</a></li>';
    //                     aMois[i] = html;
    //                     html = "";
    //                     i++;
    //                     lastMonth = day.getMonth();
    //                 }

    //                 html +='<tr class="pattern" style="">'+
    //                     '       <td class="number">'+('0' + day.getDate()).slice(-2) + '/' + ('0' + (day.getMonth()+1)).slice(-2) + '/' + day.getFullYear()+'</td>'+
    //                     '       <td class="matin">'+
    //                     '           <div class="checkbox">'+
    //                     '               <input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am\']" type="checkbox" value="am">'+
    //                     '           </div>                                     '+
    //                     '                <div class="from">De</div>'+
    //                     '           <div class="input"><input value="'+$('[name="semaine_type_am_from"]').val()+'" disabled="disabled" class="form-control horaires-time flatpickr-time am_from" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_from\']" type="text"></div>'+
    //                     '           <div class="to">Jusqu\'à</div> '+
    //                     '           <div class="input"><input value="'+$('[name="semaine_type_am_to"]').val()+'" disabled="disabled" class="form-control horaires-time flatpickr-time am_to" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_to\']" type="text"></div>'+
    //                     '       </td>'+
    //                     '       <td class="aprem">'+
    //                     '           <div class="checkbox"><input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm\']" type="checkbox" value="pm"></div>'+
    //                     '           <div class="from">De</div>'+
    //                     '           <div class="input"><input value="'+$('[name="semaine_type_pm_from"]').val()+'" disabled="disabled" class="form-control horaires-time flatpickr-time pm_from" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_from\']" type="text"></div>'+
    //                     '           <div class="to">Jusqu\'à</div>'+
    //                     '           <div class="input"><input value="'+$('[name="semaine_type_pm_to"]').val()+'" disabled="disabled" class="form-control horaires-time flatpickr-time pm_to" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_to\']" type="text"></div> '+
    //                     '       </td>'+
    //                     '   </tr>';


    //             }

    //             aMois[i] = html;
    //             list+= '<li><a href="#" data-tabs-month="tabs_'+i+'">'+dicoMois[parseInt(oEndDate.getMonth())+1]+'</a></li>';

    //             html="";

    //             aMois.forEach((item, index) => {
    //                 html +=    '    <table class="" cellspacing="0" cellpadding="0" border="0" data-tabs-month="tabs_'+index+'">'+
    //                     '        <tr>'+
    //                     '            <th class="empty"></th>'+
    //                     '            <th>Matin</th>'+
    //                     '            <th>Après-midi</th>'+
    //                     '        </tr>';
    //                 html +=item;
    //                 html +=  '    </table>';

    //             })

    //             $horairesTravailContainer.html(html);
    //             $listMonth.find('ul').html(list);

    //             $horairesTravailContainer.find('table').first().addClass('visible');
    //             $listMonth.find('a').first().addClass('active');

    //             $semaineTypeCheckboxContainer.show();

    //         }else{
    //             //unisuement date de debut
    //             let [start_date_year, start_date_month, start_date_day] = start_date.split('-');
    //             var html ="";
    //             var list ="";

    //             var oStartDate = new Date(start_date);
    //             var day = oStartDate;

    //             html =    '    <table class="visible" cellspacing="0" cellpadding="0" border="0" data-tabs-month="tabs_'+start_date_month+'_'+start_date_year+'">'+
    //                     '        <tr>'+
    //                     '            <th class="empty"></th>'+
    //                     '            <th>Matin</th>'+
    //                     '            <th>Après-midi</th>'+
    //                     '        </tr>'+
    //                     '        <tr class="pattern" style="">'+
    //                     '            <td class="number">'+start_date_day+'/'+start_date_month+'/'+start_date_year+'</td>'+
    //                     '            <td class="matin">'+
    //                     '                <div class="checkbox">'+
    //                     '                    <input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am\']" type="checkbox" value="true">'+
    //                     '                </div>                                     '+
    //                     '                <div class="from">De</div>'+
    //                     '                <div class="input"><input value="08:00" disabled="disabled" class="form-control flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_from\']" type="text"></div>'+
    //                     '                <div class="to">Jusqu\'à</div> '+
    //                     '                <div class="input"><input value="12:00" disabled="disabled" class="form-control flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'am_to\']" type="text"></div>'+
    //                     '            </td>'+
    //                     '            <td class="aprem">'+
    //                     '                <div class="checkbox"><input class="form-check checkbox" onchange="ClientMissionEdit.toggleInputNested(event);" name="day[\''+start_date_day+'-'+start_date_month+'-'+start_date_year+'\'][\'pm\']" type="checkbox" value="true"></div>'+
    //                     '                <div class="from">De</div>'+
    //                     '                <div class="input"><input value="14:00" disabled="disabled" class="form-control flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_from\']" type="text"></div>'+
    //                     '                <div class="to">Jusqu\'à</div>'+
    //                     '                <div class="input"><input value="17:00" disabled="disabled" class="form-control flatpickr-time horaires-time" name="day[\''+day.getDate()+'-'+(day.getMonth()+1)+'-'+day.getFullYear()+'\'][\'pm_to\']" type="text"></div> '+
    //                     '            </td>'+
    //                     '        </tr>'+
    //                     '        <tr>'+
    //                     '    </table>';

    //             $horairesTravailContainer.html(html);

    //             list = '<li><a href="#" class="active" data-tabs-month="tabs_'+start_date_month+'_'+start_date_year+'">'+dicoMois[parseInt(start_date_month)]+'</a></li>'
    //             $listMonth.find('ul').html(list);

    //             $semaineTypeCheckboxContainer.hide();

    //         }

    //         let $input = $('.flatpickr-time.horaires-time');

    //         $input.addClass('js-flatpickr-enabled');
    //         flatpickr($input, {
    //             //disableMobile: "true",
    //             enableTime: true,
    //             noCalendar: true,
    //             dateFormat: "H:i",
    //             time_24hr: true,
    //         //    defaultDate: this.getInputDefaultTime.apply(this, ['flatpickr-time']),
    //             onReady: function (selectedDates, dateStr, instance) {
    //                 if (instance.isMobile) {
    //                     $(instance.mobileInput).attr('step', null);
    //                 }
    //             },
    //         });


    //         $('#SystemHours').show();
    //         $('.message_date_debut_first').hide();
    //     }
    //     else
    //     {
    //         //pas de date de début

    //         $('#SystemHours').hide();
    //         $('.message_date_debut_first').show();
    //     }


    // }

    isValidDate(dateString)
    {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    }

    showEmptyLicencesAlert() {
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                // cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "info",
            showCancelButton: 0,
            customClass: {
                confirmButton: "btn btn-primary m-1",
                // cancelButton: "btn btn-danger m-1"
            },
            confirmButtonText: jsVars.closeText,
            // cancelButtonText: false,
            html: jsVars.showEmptyLicencesText,
        })
    }

    showFelicitationsAlert(typeDeMessage){
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                // cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "success",
            showCancelButton: 0,
            customClass: {
                confirmButton: "btn btn-primary m-1",
                // cancelButton: "btn btn-danger m-1"
            },
            confirmButtonText: jsVars.closeText,
            // cancelButtonText: false,
            html: jsVars.showFelicitationsText,
        })
    }


    initDescriptionTextEditor() {
        // Init full text editor
        ExaHelpers.summernoteBySelector('.js-summernote:not(.js-summernote-enabled)');
    }

    initWorkingHours() {
        this.$whInput = $('[name="working_hours"]');
       // this.workingHours = JSON.parse(this.$whInput.val());

        if (this.$whInput.val()) {
            try {
                this.workingHours = JSON.parse(this.$whInput.val());
            } catch (e) {
                this.workingHours = "";
            }
        }


        this.$whContainer = $('.working-hours-container');
        this.$whModal = $('#client-mission-working-hours-modal');
        this.$whInputsArray = $('[name*="_am_from"], [name*="_am_to"], [name*="_pm_from"], [name*="_pm_to"]');
        this.$whPrefillBtn = $('.prefill-working-hours');

        let inputsArray = [
            'wh_am_from',
            'wh_am_to',
            'wh_pm_from',
            'wh_pm_to',
            'monday_am_from',
            'monday_am_to',
            'monday_pm_from',
            'monday_pm_to',
            'tuesday_am_from',
            'tuesday_am_to',
            'tuesday_pm_from',
            'tuesday_pm_to',
            'wednesday_am_from',
            'wednesday_am_to',
            'wednesday_pm_from',
            'wednesday_pm_to',
            'thursday_am_from',
            'thursday_am_to',
            'thursday_pm_from',
            'thursday_pm_to',
            'friday_am_from',
            'friday_am_to',
            'friday_pm_from',
            'friday_pm_to',
            'saturday_am_from',
            'saturday_am_to',
            'saturday_pm_from',
            'saturday_pm_to',
            'sunday_am_from',
            'sunday_am_to',
            'sunday_pm_from',
            'sunday_pm_to',
            'semaine_type_am_from',
            'semaine_type_am_to',
            'semaine_type_pm_from',
            'semaine_type_pm_to',
        ];

        this.initWorkingHoursInput();

        for (let inputName of inputsArray) {
            let $input = $(`[name="${inputName}"]`);

            $input.addClass('js-flatpickr-enabled');
            flatpickr($input, {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                defaultDate: this.getInputDefaultTime.apply(this, [inputName]),
                onReady: function (selectedDates, dateStr, instance) {
                    if (instance.isMobile) {
                        $(instance.mobileInput).attr('step', null);
                    }
                },
            });
        }

        //this.updateWorkingHours(null, null, null);
        

        this.$whPrefillBtn.on('click', function (e) {
            this.$whModal.find('tr.monday input').each((index, element) => {
                let namePattern = element.name.replace('monday', '');
                let valueToSet = $(element).val();

                this.$whModal.find(`[name*="${namePattern}"]:not([name="${element.name}"])`).each((i, e) => {
                    $(e).val(valueToSet);

                    if (e._flatpickr.isMobile) {
                        let [hour, time] = valueToSet.split(':');
                        e._flatpickr.setDate(new Date().setHours(hour, time, false))
                    }
                });
            });

        }.bind(this))

        this.$whModal.find('.btn-confirm').on('click', function (e) {
            this.updateWorkingHours(null, null, null);
        }.bind(this));

        this.$whModal.on('show.bs.modal', function (e) {
            let json = this.$whInput.val();
            if (json) {
                try {
                    json = JSON.parse(json);
                } catch (e) {
                    return false;
                }
            }

            jQuery.each(json, function (i, val) {
                if (val !== "") {
                    this.$whModal.find(`[name="${i}"]`).val(val);
                }
            }.bind(this));
        }.bind(this));

        this.$whModal.on('hidden.bs.modal', function (e) {
            jQuery.each(this.$whModal.find('[name]'), function (i, val) {
                $(val).val('');
            }.bind(this));
        }.bind(this));
    }

    updateWorkingHours(selectedDates, dateStr, instance) {
        let whData = {};

        this.$whInputsArray.each((index, element) => {
            let $el = $(element);
            whData[$el.prop('name')] = $el.val();
        });

        this.$whInput.val(JSON.stringify(whData));
    }

    updateWorkingHoursV2(){

        let whData = {};

        var dayCheck = $('.horaires-travail .checkbox:checked');

        dayCheck.each((index, element) => {
            $(element).parent().parent().find('input[type="text"]').each((i, e) => {
                whData[$(e).prop('name')] = $(e).val();
            });
        });

        this.$whInput.val(JSON.stringify(whData));

    }

    initWorkingHoursInput(){

        $.each(this.workingHours, function (i, item) {
            $('.horaires-travail [name="' + i + '"]').removeAttr('disabled').val(item).addClass('flatpickr-time');

            let $input = $('.horaires-travail [name="' + i + '"]');
            $input.addClass('js-flatpickr-enabled');
             flatpickr($input, {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                //defaultDate: this.getInputDefaultTime.apply(this, [inputName]),
                defaultDate: $input.val(),
                onReady: function (selectedDates, dateStr, instance) {
                    if (instance.isMobile) {
                        $(instance.mobileInput).attr('step', null);
                    }
                },
            });
        


            $('.horaires-travail [name="'+i+'"').parent().parent().parent().parent().find('input[type="checkbox"]').attr('checked','checked');
        });

    }

    getInputDefaultTime(inputName) {
        if (typeof this.workingHours[inputName] !== "undefined" && this.workingHours[inputName] !== "") {
            return this.workingHours[inputName];
        }

        if (inputName === 'wh_am_from' && inputName.indexOf("am_from") !== -1) {
            return "08:00";
        } else if (inputName === 'wh_am_to' && inputName.indexOf("am_to") !== -1) {
            return "12:00";
        } else if (inputName === 'wh_pm_from' && inputName.indexOf("pm_from") !== -1) {
            return "13:00";
        } else if (inputName === 'wh_pm_to' && inputName.indexOf("pm_to") !== -1) {
            return "17:30";
        }

        return "";
    }

    initMap() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 17
        });

        let latVal = parseFloat(this.latInput.val());
        let lngVal = parseFloat(this.lngInput.val());

        if (latVal > 0 || lngVal > 0) {
            this.showOnMap(parseFloat(this.latInput.val()), parseFloat(this.lngInput.val()));
        } else {
            this.map.setCenter({lat: 46.801111, lng: 8.226667});
            this.map.setZoom(6);
        }

        this.map.addListener('click', function (event) {
            this.handleMapClick(event);
        }.bind(this));
    }

    initAutocomplete(selectedCountryCode) {
        let acInput = document.getElementById('autocomplete');
        let type = '';

        $(acInput).on('focus', function (e) {
            ClientMissionEdit.acSelected = false;
        }).on('blur', function (e) {
            setTimeout(function () {
                type = document.activeElement ? document.activeElement.type : '';
                if (!ClientMissionEdit.acSelected && type !== 'search' && type !== 'button') {
                    ClientMissionEdit.clearAddressAndAlert();
                }
            }, 500);
        });

        this.autocomplete = new google.maps.places.Autocomplete(
            acInput, {
                types: ['address'],
                region: 'EU',
                strictBounds: true,
                fields: ['address_component', 'geometry', 'name'],
                componentRestrictions: {country: selectedCountryCode},
            }
        );

        $(acInput).bind('keypress keydown keyup', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });

        this.autocomplete.addListener('place_changed', function () {
            ClientMissionEdit.acSelected = true;
            let place = this.autocomplete.getPlace();

            if (typeof place["address_components"] == "undefined") {
                ClientMissionEdit.clearAddressAndAlert();
            }
            $('[name="address_line_1"]').val(place['name']);
            $('[name="city"]').val(this.getAddressComponentByType(place["address_components"], 'locality', 'long_name'));
            $('[name="postcode"]').val(this.getAddressComponentByType(place["address_components"], 'postal_code', 'long_name'));
            $('[name="google_maps_result"]').val(JSON.stringify(place));
            this.showOnMap(place.geometry.location.lat(), place.geometry.location.lng());
            this.updateLatLngInputs(place.geometry.location);
        }.bind(this));
    }

    static clearAddressAndAlert() {
        $('[name="address_line_1"], [name="address_line_2"], [name="postcode"], [name="city"], [name="google_maps_result"], [name="lat"], [name="lng"]').val('');
        alert(jsVars.acSelectText);
    }

    initCountryRestriction() {
        let selectedCountryCode = 'ch';

        if (typeof this.autocomplete === "undefined") {
            this.initAutocomplete(selectedCountryCode);
        } else {
            this.autocomplete.setComponentRestrictions({country: [selectedCountryCode]});
        }
    }

    showOnMap(geoLat, geoLng) {
        let myLatLng = {lat: geoLat, lng: geoLng};

        let marker = new google.maps.Marker({
            position: myLatLng,
            map: this.map,
        });

        this.clearOverlays();
        this.markersArray.push(marker);
        this.showOverlays();

        this.map.panTo(myLatLng);
        this.map.setZoom(17);
    }

    getAddressComponentByType(addressComponents, addressType, property) {
        let result = '';
        if (addressComponents) {
            addressComponents.forEach(function (element) {
                if (element['types'].indexOf(addressType) !== -1) {
                    result = element[property];
                    return false;
                }
            });
        }
        return result;
    }

    // Removes the overlays from the map, but keeps them in the array
    clearOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(null);
            }
        }
        this.markersArray = [];
    }

    // Shows any overlays currently in the array
    showOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(this.map);
            }
        }
    }

    handleMapClick(event) {
        this.clearOverlays();
        let marker = new google.maps.Marker({
            position: event.latLng,
            map: this.map
        });
        this.markersArray = [];
        this.markersArray.push(marker);
        this.showOverlays();
        this.updateLatLngInputs(event.latLng);
    }

    updateLatLngInputs(latLng) {
        this.latInput.val(latLng.lat).change();
        this.lngInput.val(latLng.lng).change();
    }

    toggleExpensesDetails(e) {
        let $target = $(e.target);
        let $detailsFormGroup = $target.parent().next('.form-group');

        if ($target.prop('checked')) {
            $detailsFormGroup.show();
        } else {
            $detailsFormGroup.hide();
        }
    }

    toggleNoEndDate(e) {
        let $target = $(e.target);
        let $endDateInputContainer = $target.parent().nextAll('.end-date-container');
        let flatpickrInput = $endDateInputContainer.find('input.js-flatpickr-enabled.flatpickr-input')[0];

       // let $semaineTypeCheckboxContainer = $('.semaine-type-check');

       // let $horairesTravailContainer = $('.horaires-travail');
        //let $listMonth = $('.list-month');

        if ($target.prop('checked')) {
            $endDateInputContainer.hide();
            flatpickrInput._flatpickr.setDate('9999-12-31');
           // $semaineTypeCheckboxContainer.hide();
           // $horairesTravailContainer.hide();
           // $listMonth.hide();

            window["ClientMissionEdit"].updateSystemHours($('#start_date_datepicker').val(), "");

        } else {
            if ($(flatpickrInput).val() === "" || $(flatpickrInput).val() === '9999-12-31') {
                flatpickrInput._flatpickr.setDate('');
                flatpickrInput._flatpickr.jumpToDate(flatpickrInput._flatpickr.config.minDate || new Date());
            }
            $endDateInputContainer.show();
          //  $horairesTravailContainer.show();
          //  $listMonth.show();
          //  $semaineTypeCheckboxContainer.show();
        }
    }

    toggleSemaineType(e){
        let $target = $(e.target);
        let $semaineTypeInputContainer = $('.semaine-type');

        if (!$target.prop('checked')) {
            $semaineTypeInputContainer.hide();
        } else {
            $semaineTypeInputContainer.show();
        }

    }

   /*
    switchMonth(e){
         e.preventDefault();
        let $target = $(e.target);

        $('.horaires-travail.visible').removeClass('visible');

        $('.horaires-travail[data-tabs-month="'+$target.attr('data-tabs-month')+'"]').addClass('visible');
    }
*/

    toggleInputNested(e){
        let $target = $(e.target);
        let $containerNested = $(e.target).parent().parent();

        if (!$target.prop('checked')) {
            $containerNested.find('input[type=text]').attr('disabled','disabled');
            $containerNested.find('input[type=time]').attr('disabled','disabled');
            $containerNested.find('input[type=hidden]').attr('disabled','disabled');
        } else {
            $containerNested.find('input[type=text]').removeAttr('disabled');
            $containerNested.find('input[type=time]').removeAttr('disabled');
            $containerNested.find('input[type=hidden]').removeAttr('disabled');
        }
    }

    initDropzone() {
        let $missionFiles = $('#mission-files-dropzone');
        $missionFiles.addClass('dropzone');
        $missionFiles.dropzone(
            {
                url: jsVars.saveFileUrl,
                init: function () {
                    let thisDropzone = this;
                    let $thisElement = $(thisDropzone.element);

                    thisDropzone.inputField = $thisElement.find('input');
                    thisDropzone.modelId = $thisElement.parents('.modal').find('[name="id"]').val();
                    thisDropzone.modelId = typeof thisDropzone.modelId === "undefined" ? '' : thisDropzone.modelId;

                    thisDropzone.preloadedFiles = [];
                    if (thisDropzone.inputField.length !== 0) {
                        thisDropzone.preloadedFiles = thisDropzone.inputField.val();

                            if (thisDropzone.preloadedFiles) {
                                try {
                                    thisDropzone.preloadedFiles = JSON.parse(thisDropzone.preloadedFiles);
                                } catch (e) {
                                    thisDropzone.preloadedFiles = "";
                                }
                            }


                        

                    }

                    $.each(thisDropzone.preloadedFiles, function (key, value) {
                        if (!value) {
                            return;
                        }
                        let file = {
                            processing: true,
                            accepted: true,
                            name: value.originalName,
                            size: value.size,
                            type: value.mimeType,
                            status: Dropzone.SUCCESS,
                            downloadLink: value.path,
                            dbData: value,
                        };
                        thisDropzone.files.push(file);
                        thisDropzone.emit("addedfile", file);
                        if (value.thumbnail) {
                            thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                        }
                        thisDropzone.emit("processing", file);
                        thisDropzone.emit("success", file, {status: "success"}, false);
                        thisDropzone.emit("complete", file);
                        file.path = value.path;
                    });

                    $thisElement.on('click', '[data-dz-name]', function (e) {
                        let $target = $(e.target);
                        let $fileContainer = $target.parents('.dz-preview');
                        let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                        window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                    });

                    thisDropzone.on("removedfile", function (file) {
                        this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                    });

                    thisDropzone.on("addedfile", function (file) {
                        $thisElement.parents('.modal').find('button').prop('disabled', true);
                    });

                    thisDropzone.on("complete", function (file) {
                        $thisElement.parents('.modal').find('button').prop('disabled', false);
                    });
                },
                sending: function (file, xhr, formData) {
                    formData.append("_token", Laravel.csrfToken);
                    formData.append("id", this.modelId);
                },
                success: function (file, response) {
                    if (typeof response.uploadedFile !== "undefined") {
                        // This is an ajax response
                        file.path = response.uploadedFile.path;
                        file.dbData = response.uploadedFile;
                        this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));

                        $(file.previewElement).addClass("dz-success");
                        setTimeout(function () {
                            $(file.previewElement).removeClass("dz-success");
                        }, 2750);

                        Dashmix.helpers('notify', {
                            align: 'center',
                            type: 'success',
                            icon: 'fa fa-check mr-1 mt-5 mb-5',
                            message: jsVars.fileUploadedSuccessTab
                        });
                    }
                    let link = file.downloadLink || file.path;
                    if (link) {
                        // Save download link to hidden input for click to open to work
                        file.previewTemplate.insertAdjacentHTML('beforeend',
                            `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                    }
                },
                error: function (file, message) {
                    $(file.previewElement).addClass("dz-error");
                    if (message.errors) {
                        $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                    }
                },
                addRemoveLinks: true,
            }
        );
    }

    initValidation() {
        this.$missionUpdateForm.validate({
            ignore: "[contenteditable='true']:not([name])",
            rules: {
                'jobTitles[]': {
                    required: true,
                },
                'titre': {
                    required: true,
                },
                'description': {
                    required: true,
                },
                'start_date': {
                    dateISO: true,
                    required: true,
                },
                'end_date': {
                    dateISO: true,
                    required: !$('[name="no_end_date"]').prop('checked'),
                },
                'address_line_1': {
                    required: true,
                },
                'city': {
                    required: true,
                },
                'postcode': {
                    required: true,
                },
                'contact_person_phone_intl': {
                    intlTelNumber: true,
                },
            },
        });

        // Init Validation on Select2 change
        $('.js-select2:not(.skip-validation)').on('change', e => {
            $(e.currentTarget).valid();
        });

        let swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        let formArray;
        setTimeout(() => {
            // Remove field active from modifications check, ignore changes to this fields, use delay so intl loads
            formArray = $.param(this.$missionUpdateForm.serializeArray().filter(function (value) {
                return !jsVars.ignoredClientModificationFields.includes(value.name);
            }));
            this.$missionUpdateForm.data('serialize', formArray);
        }, 1);

        let $previewModal = $('#client-preview-mission-modal');
        this.$missionUpdateForm.on('click', '.preview', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            if (!$form.valid()) {
                return;
            }

            $.ajax({
                type: 'POST',
                url: $(e.target).attr('formaction') + '?minimal_layout=true',
                data: $form.serialize(),
            }).then((response) => {
                $previewModal.find('.modal-content').html('');
                let iframeId = Math.random().toString(36).substring(7);
                let $iframe = $(`<iframe id="${iframeId}">`).appendTo($previewModal.find('.modal-content'));
                let doc = $iframe[0].contentWindow.document;
                doc.open();
                doc.write(response);
                doc.close();
                $iframe.contents().find("head")
                    .append($(`
                        <style type='text/css'>
                            
                            #main-container { margin-bottom: 12px; }
                            #page-container.page-header-fixed #main-container {
                                padding-top: 0;
                            }
                            #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                                display:none !important;
                            }
                            #page-container.sidebar-o {
                                padding-left: 0;
                            }
                            .main-container {
                                left: 0px !important;
                                top: 0px !important;
                                padding: 0 60px !important;
                                margin-left: 0px !important;
                                margin-top: 0px !important;
                                margin-bottom: 26px;
                                max-width: 99% !important;
                            }
                            .layout-container.view {
                                max-width: 100% !important
                            }
                            @media(max-width:992px) {
                                .main-container {
                                    padding: 0 !important;
                                }
                            }
                        </style>`));
                $previewModal.modal('show');
                $iframe.height('67.5vh');
                $iframe.css('border', 0);
            }).fail((e) => {
                console.log(e);
            });
        });

        this.$missionUpdateForm.on('click', '[type="submit"].js-swal-confirm', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            window["ClientMissionEdit"].updateWorkingHoursV2();

            if (!$form.valid()) {
                let $firstInput = $form.find('[name="' + Object.keys($form.validate().invalid)[0] + '"]');
                $('a.nav-link[href="#' + $firstInput.closest('.tab-pane').prop('id') + '"]').tab('show');
                return false;
            }



            formArray = $.param($form.serializeArray().filter(function (value) {
                return !jsVars.ignoredClientModificationFields.includes(value.name);
            }));
            if (formArray !== $form.data('serialize') && jsVars.alreadyExisting) {
                // Form has changed
                swal.fire({
                    title: jsVars.confirmActionTitle,
                    html: jsVars.confirmModificationTitle,
                    icon: "warning",
                    showCancelButton: !0,
                    customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                    confirmButtonText: jsVars.confirmButtonText,
                    cancelButtonText: jsVars.cancelButtonText,
                    preConfirm: function (e) {
                        return $form.submit();
                    }
                })
            } else {
                return $form.submit();
            }
        })
    }

    initEndMission() {
        let $descBox = $('#end_mission_description').parents('.form-group');
        $('#end_mission_reason_id').change(function (e) {
            let $target = $(e.target);

            if ($target.val() === `${jsVars.endMissionReasonOtherId}`) {
                $descBox.show();
            } else {
                $descBox.hide();
            }
        })

        let $endMissionForm = $('#end-mission-modal form');
        let $immediateMissionEnd = $endMissionForm.find('[name="immediate_mission_end"]');
        let $modifiedEndDateContainer = $endMissionForm.find('.modified-end-date-container');

        $immediateMissionEnd.on('change', function (e) {
            if ($(e.target).prop('checked')) {
                $modifiedEndDateContainer.hide();
            } else {
                $modifiedEndDateContainer.show();
            }
        }).change();

        $endMissionForm.validate({
            ignore: [],
            rules: {
                'modified_end_date': {
                    required: function (element) {
                        return $immediateMissionEnd.length !== 0 && $immediateMissionEnd.prop('checked') !== true;
                    },
                },
                'end_mission_reason_id': {
                    required: true,
                },
                'message': {
                    required: true,
                },
            },
        });
    }

    initJobTitlesAutocomplete() {
        ClientMissionEdit.removedAcItems = [];

        const fuse = new Fuse(jsVars.jobTitlesAutocomplete, {
            minMatchCharLength: 3,
            threshold: 0.3,
            distance: 1000,
            keys: ["genderNeutral"],
            getFn: (obj, path) => {
                return obj.genderNeutral.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $("#jobTitlesAutocomplete");
        let $acContainer = $jtAc.parent().find('.autocomplete-container');
        let $jtInput = $('select[name="jobTitles[]"]');

        if ($jtInput.prop('disabled')) {
            // Makes no sense to load the rest when input is disabled
            return false;
        }

        $jtAc.autocomplete({
            delay: 0,
            minLength: 2,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.genderNeutral});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;
                $jtInput.append($('<option>', {
                    value: value,
                    text: label
                }));

                $jtInput.find(`option[value="${value}"]`).prop('selected', true);
                $jtInput.change();
                $acContainer.append(`
                    <span class="autocomplete-item" data-value="${value}"><i class="fa fa-fw fa-times"></i>${label}</span>
                `);

                let indexToRemove = fuse._docs.findIndex(x => x.id === parseInt(value));
                if (indexToRemove !== -1) {
                    ClientMissionEdit.removedAcItems.push(fuse._docs[indexToRemove]);
                    fuse.removeAt(indexToRemove);
                }

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });

        $.each($jtInput.val(), function (_i, value) {
            let indexToRemove = fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                ClientMissionEdit.removedAcItems.push(fuse._docs[indexToRemove]);
                fuse.removeAt(indexToRemove);
            }
        })

        $acContainer.on('click', '.fa-times', function (e) {
            let $item = $(e.target).parent();
            let value = $item.data('value');
            let $option = $jtInput.find(`option[value="${value}"]`);

            $option.prop('selected', false);
            $option.remove();
            $item.remove();
            $jtInput.change();

            let indexToAdd = ClientMissionEdit.removedAcItems.findIndex(x => x.id === parseInt(value));
            if (indexToAdd !== -1) {
                fuse.add(ClientMissionEdit.removedAcItems[indexToAdd]);
            }
        })
    }

    initPotentialCandidatesNumber() {
        let timeout = null;
        let that = this;

        that.$potentialCandidates = $('.potential-candidates');

        if (that.$potentialCandidates.length === 0) {
            return;
        }

        that.$potentialCandidates.draggable();
        that.$numberTag = that.$potentialCandidates.find('.potential-candidates-number');

        this.$missionUpdateForm.on('change', 'select, textarea, input', function (e) {
            let $form = $(e.target).parents('form');
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                that.loadPotentialCandidates($form);
              //  that.loadPotentialCandidatesList($form);
                that.loadPotentialCandidatesCadenced($form);
            }.bind(this), 350);
        })
    }

    loadPotentialCandidates($form) {
        let that = this;

        let requiredMissionMatching = [
            'jobTitles[]',
            'lat',
            'lng',
        ];

        let allRequiredFilled = true;
        $.each(requiredMissionMatching, function (_i, value) {
            let $el = $form.find(`[name="${value}"]`);
            let val = $el.val();

            if (Array.isArray(val) && !val.length) {
                allRequiredFilled = false;
                return false;
            }
            if (val === "") {
                allRequiredFilled = false;
                return false;
            }
        })

        if (!allRequiredFilled) {
            that.$numberTag.html('-');
            that.$potentialCandidates.find('.multiple').hide();
            that.$potentialCandidates.find('.single').show();
            return;
        }

        $.ajax({
            type: 'POST',
            url: jsVars.potentialCandidatesUrl,
            data: $form.serialize(),
        }).then((response) => {
            let numberOfCandidates = parseInt(response);
            if (isNaN(numberOfCandidates)) {
                that.$potentialCandidates.find('.multiple').hide();
                that.$potentialCandidates.find('.single').show();
                return that.$numberTag.html('-');
            }

            that.$numberTag.html(numberOfCandidates);
            if (numberOfCandidates > 1) {
                that.$potentialCandidates.find('.multiple').show();
                that.$potentialCandidates.find('.single').hide();
            } else {
                that.$potentialCandidates.find('.multiple').hide();
                that.$potentialCandidates.find('.single').show();
            }

           // $('.list_teamer_match').html('').hide();

        }).fail((e) => {
            console.log("Error: ", e);
        });
    }

    loadPotentialCandidatesCadenced($form) {
        let that = this;

        let requiredMissionMatching = [
            'jobTitles[]',
            'lat',
            'lng',
        ];

        let allRequiredFilled = true;
        $.each(requiredMissionMatching, function (_i, value) {
            let $el = $form.find(`[name="${value}"]`);
            let val = $el.val();

            if (Array.isArray(val) && !val.length) {
                allRequiredFilled = false;
                return false;
            }
            if (val === "") {
                allRequiredFilled = false;
                return false;
            }
        })

        if (!allRequiredFilled) {
            that.$numberTag.html('-');
            return;
        }

        $('.lat_lng input').prop('disabled', false);

        $.ajax({
            type: 'POST',
            url: jsVars.potentialCandidatesCadencedUrl,
            data: $form.serialize(),
        }).then((response) => {

            var v1 = parseInt(response[0]);
            var v2 = parseInt(response[1]);
            var v3 = parseInt(response[2]);
            var v4 = parseInt(response[3]);

            $('.vague_1').html(v1);
            $('.vague_2').html(v2);
            $('.vague_3').html(v3);
            $('.vague_4').html(v4);

        }).fail((e) => {
            console.log("Error: ", e);
        });
    }


    loadPotentialCandidatesList($form) {
        let that = this;

        let requiredMissionMatching = [
            'jobTitles[]',
            'lat',
            'lng',
        ];

        let allRequiredFilled = true;
        $.each(requiredMissionMatching, function (_i, value) {
            let $el = $form.find(`[name="${value}"]`);
            let val = $el.val();

            if (Array.isArray(val) && !val.length) {
                allRequiredFilled = false;
                return false;
            }
            if (val === "") {
                allRequiredFilled = false;
                return false;
            }
        })

        if (!allRequiredFilled) {
            that.$numberTag.html('-');
            that.$potentialCandidates.find('.multiple').hide();
            that.$potentialCandidates.find('.single').show();
            return;
        }

        let html= "";

        $('.lat_lng input').prop('disabled', false);

        $.ajax({
            type: 'POST',
            url: jsVars.potentialCandidatesListUrl,
            data: $form.serialize(),
        }).then((response) => {
        //$('.lat_lng input').prop('disabled', true);
            response.forEach((item, index) => {
                html += `
                    <div class="teamer_match_item">
                        <div class="d-flex align-items-center">
                            <input class="nowatch" type="checkbox" name="custom_matching[]" value="${item['candidate']['user']['id']}" />
                            <a href="#" class="empty-link" data-target="#client-candidate-show-modal" data-remote="https://teameo.ch/app/consultant/candidates/show/${item['candidate']['user']['id']}" data-toggle="modal">
                                <span class="pl-2">
                                    ${item['candidate']['user']['first_name']} ${item['candidate']['user']['last_name']}
                                </span>
                            </a>
                        </div>
                        <span>
                            ${item['score']}%
                        </span>
                    </div>
                `
            });


        $('.list_teamer_match').html(html).show();

        if( $('#custom_matching_list').val() != "" ){

            $('.list_teamer_match input').prop('checked', false);

             let custom_matching_list = $('#custom_matching_list').val().split(',');

             custom_matching_list.forEach((item, index) => {
                $(".list_teamer_match input[value='"+item+"']").prop('checked', true);
             });

         }else{
                 $('.list_teamer_match input').prop('checked', true);
         }

            if($('#btn_teamer_match').prop('disabled') == true){
                $('.list_custom_matching input').prop('disabled', true);
            }


        }).fail((e) => {
            console.log("Error: ", e);
           // $('.lat_lng input').prop('disabled', true);
        });
    }


    static initLanguagesSelect($languagesSelect) {
        let app = this;
        app.removedAcItems = [];

        app.fuse = new Fuse(jsVars.languagesAutocompleteValues, {
            minMatchCharLength: 1,
            threshold: 0.3,
            distance: 1000,
            keys: ["name"],
            getFn: (obj, path) => {
                return obj.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $languagesSelect;
        let selectedValues = [];
        $('[type="hidden"][name*="userable[languages]"]').each(function (_i, val) {
            let parsedId = parseInt(ExaHelpers.extractFieldFromName($(val).prop('name')));
            if (!isNaN(parsedId)) {
                selectedValues.push(parsedId);
            }
        })

        $jtAc.autocomplete({
            delay: 0,
            minLength: 0,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(app.fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.name, wholeObject: obj.item});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;

                let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
                if (indexToRemove !== -1) {
                    app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                    app.fuse.removeAt(indexToRemove);
                }

                let newValue = ui.item.wholeObject;

                // Custom part - start
                let $table = $('.languages-table');

                let optionsHtml = '';
                for (let i in jsVars.languageLevelsArray) {
                    optionsHtml += `<option value="${i}">${jsVars.languageLevelsArray[i]}</option>`;
                }
                let $htmlToAppend = $(app.languagesRowTemplate(newValue, null));
                $htmlToAppend.find('select').append(optionsHtml);

                $table.find('tbody').append($htmlToAppend);

                if ($table.find('tr.single-language') && $table.find('tr.single-language').length !== 0) {
                    $table.show();
                } else {
                    $table.hide();
                }

                // Custom part - end

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });

        $.each(selectedValues, function (_i, value) {
            let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                app.fuse.removeAt(indexToRemove);
            }
        })
    }


}

